export const ANALYTICS_ACTION_TYPES = {
  SHOW: "Show",
  CLICK: "Click",
};
